import { Reservations, ReservCell } from 'entities/Reservations';

import {
  CLEAN_BOOK_STATE,
  CLEAN_ERROR_BOOK,
  CLEAN_IDDP,
  CREATE_CELL_REQUEST,
  CREATE_CELL_SUCCESS,
  DELETE_ORDERS_MODAL,
  GET_ORDERS_BOOK_ERROR,
  GET_ORDERS_BOOK_REQUEST,
  GET_ORDERS_BOOK_SUCCESS,
  GET_ORDERS_OZM_ERROR,
  GET_ORDERS_OZM_REQUEST,
  GET_ORDERS_OZM_SUCCESS,
  SET_MODAL_BOOK,
  SET_MODAL_EDIT_BOOK,
} from './constants';

export const getOrdersBookRequest = (orderObject: string, bookValue: any, roleId: number) => ({
  type: GET_ORDERS_BOOK_REQUEST,
  payload: { orderObject, bookValue, roleId },
});

export const deleteOrdersModal = (body: any) => ({
  type: DELETE_ORDERS_MODAL,
  payload: body,
});

export const getOrdersBookSuccess = (bookValue: any, response: any, error: any) => ({
  type: GET_ORDERS_BOOK_SUCCESS,
  payload: bookValue,
  response,
  error,
});

export const getOrdersBookError = (error: any, bookValue: any) => ({
  type: GET_ORDERS_BOOK_ERROR,
  payload: error,
  bookValue,
});

export const cleanErrorBook = () => ({
  type: CLEAN_ERROR_BOOK,
});

export const cleanBookState = () => ({
  type: CLEAN_BOOK_STATE,
});

export const setModalBook = (bookModal: ReservCell | null) => ({
  type: SET_MODAL_BOOK,
  payload: bookModal,
});

export const setModalEditBook = (book: Reservations | null) => ({
  type: SET_MODAL_EDIT_BOOK,
  payload: book,
});

export const createCellRequest = (checkInDate: string, checkOutDate: string, isBlocked: boolean = false) => ({
  type: CREATE_CELL_REQUEST,
  checkInDate,
  checkOutDate,
  isBlocked,
});
export const createCellSuccess = (book: ReservCell) => ({
  type: CREATE_CELL_SUCCESS,
  payload: book,
});

export const clearIddp = () => ({
  type: CLEAN_IDDP,
});

export const getOrdersOzmRequest = (orderObject: string, bookValue: any, roleId: number) => ({
  type: GET_ORDERS_OZM_REQUEST,
  payload: { orderObject, bookValue, roleId },
});

export const getOrdersOzmSuccess = (response: any) => ({
  type: GET_ORDERS_OZM_SUCCESS,
  response,
});

export const getOrdersOzmError = (error: any) => ({
  type: GET_ORDERS_OZM_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof setModalBook>
  | ReturnType<typeof setModalEditBook>
  | ReturnType<typeof getOrdersBookRequest>
  | ReturnType<typeof getOrdersBookSuccess>
  | ReturnType<typeof getOrdersOzmRequest>
  | ReturnType<typeof getOrdersOzmSuccess>
  | ReturnType<typeof getOrdersOzmError>
  | ReturnType<typeof getOrdersBookError>
  | ReturnType<typeof cleanErrorBook>
  | ReturnType<typeof cleanBookState>
  | ReturnType<typeof createCellRequest>
  | ReturnType<typeof deleteOrdersModal>
  | ReturnType<typeof createCellSuccess>
  | ReturnType<typeof clearIddp>;
